/** Shared YouTube IDs used across public marketing surfaces. */
export const JOBUWIN_INTRO_VIDEO_ID = "DfhAWUk3-yI";
export const HIRING_MANAGERS_VIDEO_ID = "TvJj0oJA1xE";
export const APPLYING_FOR_JOBS_VIDEO_ID = "XPAB7FGaqG8";
/** How it works — applying product demo. */
export const APPLYING_HOW_IT_WORKS_VIDEO_ID = "P-bM4qHOcwY";
/** How it works — hiring product demo. */
export const HIRING_HOW_IT_WORKS_VIDEO_ID = "hPZuDRMtaRU";
/** Guest job detail bar — “Watch this: Why join us?” */
export const GUEST_JOB_WHY_VIDEO_ID = APPLYING_HOW_IT_WORKS_VIDEO_ID;

export function youtubeWatchUrl(videoId) {
  const id = String(videoId || "").trim();
  return id ? `https://www.youtube.com/watch?v=${encodeURIComponent(id)}` : "";
}

export function youtubeEmbedUrl(videoId) {
  const id = String(videoId || "").trim();
  return id ? `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?rel=0` : "";
}

const THUMBNAIL_FILES = {
  maxres: "maxresdefault.jpg",
  sd: "sddefault.jpg",
  hq: "hqdefault.jpg",
};

export function youtubeThumbnailUrl(videoId, quality = "maxres") {
  const id = String(videoId || "").trim();
  if (!id) return "";
  const file = THUMBNAIL_FILES[quality] || THUMBNAIL_FILES.maxres;
  return `https://i.ytimg.com/vi/${encodeURIComponent(id)}/${file}`;
}
